import { render, staticRenderFns } from "./Config2.vue?vue&type=template&id=0aecbb3a&scoped=true"
import script from "./Config2.vue?vue&type=script&lang=js"
export * from "./Config2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aecbb3a",
  null
  
)

export default component.exports